module.exports = __webpack_public_path__ + "static/media/CancelIcon.225e14a5.svg";